import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_1: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-1" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/4F79F2EA-D84C-417B-BEDC-27347A9B0CB4_w1920_r4.jpg'
          }
        />
        <h2>
          <span>1</span>
          Крим. Анексія
          <strong>{texts.menu_2}</strong>
        </h2>
      </TimelineTitle>
      <ContainerLarge>
        <TimelineIntro>
          Де-факто російська агресія проти України, яка досягла кульмінації у
          лютому 2022-го року, почалася в Криму за 8 років до того. У Києві ще
          перебував тодішній президент Віктор Янукович, коли Володимир Путін дав
          наказ захопити на півострів – про це, зокрема, свідчить дата на медалі
          «За повернення Криму», яку російське Міноборони роздавало учасникам
          захоплення: 20 лютого 2014 року. Попри заяви керівництва Росії,
          анексія Криму не була «безкровною» – українські військові та
          громадські активісти, зокрема, кримські татари, чинили відчайдушний
          спротив військовим без знаків розрізнення – часто в умовах відсутності
          наказів із Києва та загальної розгубленості української влади. На
          думку багатьох експертів, саме блискавичний успіх анексії – коли
          менше, ніж за місяць, Росія провела псевдореферендум, оголосила про
          анексію та добилася виводу українських військових з півострова –
          заохотив Кремль до спроб повторити цей успіх на півдні та сході
          України.
        </TimelineIntro>
        <TimelineContent>
          <TimelineSubtitle>20 лютого</TimelineSubtitle>
          <p>
            У Криму вперше фіксують активне переміщення російської військової
            техніки.
          </p>

          <TimelineSubtitle>21 лютого</TimelineSubtitle>
          <p>
            Партія «Русское единство», яку очолював Сергій Аксьонов, створює у
            Криму збройне формування «Народное ополчение». Його учасники
            нападають на кримчан, які прийшли до Верховної Ради Криму підтримати
            Майдан (у Києві на той момент відбувається Революція гідності, й у
            багатьох містах країни збираються місцеві Євромайдани – не став
            винятком і Крим). Вже невдовзі після анексії Криму «Народное
            ополчение», що подавало себе як нібито стихійну ініціативу, увійде
            до служби мобілізаційної роботи при окупаційній адміністрації та
            отримуватиме зарплату з бюджету РФ.
          </p>

          <TimelineSubtitle>22 лютого</TimelineSubtitle>
          <p>
            До Криму таємно приїжджає президент Віктор Янукович, який втік із
            Києва під час Майдану. Цього дня Україна усунула його від влади.
          </p>

          <TimelineSubtitle>25 лютого</TimelineSubtitle>
          <p>
            У Ялті фіксують російську військову техніку з так званими «зеленими
            чоловічками» – озброєними людьми у військовій формі без
            розпізнавальних знаків.
          </p>
          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/04230000-0aff-0242-ea1b-08daad5c855e_w1000.jpg'
              }
            />
          </TimelineImage>

          <TimelineSubtitle>26 лютого</TimelineSubtitle>
          <p>
            У Сімферополі біля Верховної Ради АР Крим проходить масовий мітинг,
            який організував Меджліс кримськотатарського народу. За різними
            оцінками в акції беруть участь від 10 до 20 тисяч кримських татар та
            проукраїнських кримчан інших національностей. Вони озвучують вимогу
            «зберегти територіальну цілісність України». Відбуваються перші
            зіткнення із представниками проросійських сил, котрі також прийшли
            під парламент. Місцеві жителі помічають, що Керчі починають
            прибувати кубанські козаки та інші активісти із Російської
            Федерації. Вони роз'їжджаються кримськими містами і видають себе за
            кримчан, які підтримують Росію.
          </p>
          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/DA061C20-9EE6-4495-9E6C-292F08721D5F_w1000.jpg'
              }
            />
          </TimelineImage>

          <TimelineSubtitle>27 лютого</TimelineSubtitle>
          <p>
            В Сімферополі російські військові захоплюють головні адміністративні
            будівлі – Раду міністрів Криму та Верховну Раду АРК. Кремль
            заперечує присутність військових РФ на півострові. В українських ЗМІ
            з'являється термін/мем «ИХТАМНЕТ» на честь фрази, якою Володимир
            Путін відповів на запитання про присутність його військ у Криму.
          </p>
          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/4F79F2EA-D84C-417B-BEDC-27347A9B0CB4_w1000.jpg'
              }
            />
            <span>
              Російські військові без упізнавальних знаків біля українсткої
              військової частини у Перевальному
            </span>
          </TimelineImage>

          <TimelineSubtitle>28 лютого</TimelineSubtitle>
          <p>
            Російська армія в ніч на 28 лютого захоплює кримський міжнародний
            аеропорт у Сімферополі, військові аеродроми Бельбек в Севастополі та
            Кіровському. Вперше окупанти на камеру самі зізнаються журналістам,
            що вони із Росії. Також відбувається захоплення державної
            телерадіокомпанії «Крим». В'їзд з материка на півострів блокують
            колишні бійці спецпідрозділу «Беркут» – встановлюють блокпости на
            основних трасах.
          </p>
          <TimelineVideo id={'KI91EF1ZlNI'} />

          <TimelineSubtitle>1 березня</TimelineSubtitle>
          <p>
            У Сімферополі, Бахчисараї, Перевальному, Новоозерному, Керчі,
            Феодосії розпочинається блокада «зеленими чоловічками» військових
            частин ЗСУ. Водночас, українське командування наказує військовим не
            чинити опір окупантам.
          </p>
          <TimelineVideo id={'9dzFF_e36mw'} />

          <TimelineSubtitle>3 березня</TimelineSubtitle>
          <p>
            10-а Сакська бригада морської авіації під командуванням Ігоря Бедзая
            проводить успішну спецоперацію – перекидає з аеродрому у
            Новофедорівці три літаки та шість вертольотів на аеродром в
            Миколаєві. Українські військові кораблі в Криму заблоковані
            російською армією.
          </p>
          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/16C025E1-8CBF-4C22-B288-73C69724FC3F_w1000.jpg'
              }
            />
            <span>
              Член екіпажу корабля «Тернопіль» чергує на палубі 5 березня
            </span>
          </TimelineImage>

          <TimelineSubtitle>4 березня</TimelineSubtitle>
          <p>
            Командир Севастопольської 204 бригади тактичної авіації Юлій Мамчур
            провів колону українських бійців без зброї на аеродром Бельбек, який
            захопили російські військові, щоб розблокувати територію. Вперше в
            Криму солдати армії РФ відкривають вогонь, поки що в повітря.
          </p>
          <TimelineVideo id={'UL5TT4fuJA0'} />

          <TimelineSubtitle>7 березня</TimelineSubtitle>
          <p>
            У Севастополі під час штурму військової частини А2355 невідомі в
            балаклавах нападають зі зброєю на журналістів, котрі висвітлюють
            блокування частини.
          </p>

          <TimelineSubtitle>8 березня</TimelineSubtitle>
          <p>
            У Сімферополі захоплюють військкомат. З боку Криму вперше
            обстрілюють український прикордонний літак. Російські військові
            захоплюють прикордонну службу в місті Щолкіне.
          </p>
          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/5A242A85-27CD-40D9-A8D7-F903FF83FB2B_w1000.jpg'
              }
            />
            <span>
              Мітинг жінок на підтримку України у Сімферополі 8 березня
            </span>
          </TimelineImage>

          <TimelineSubtitle>16 березня</TimelineSubtitle>
          <p>
            Росія проводить в Криму без доступу міжнародних спостерігачів та
            всупереч українським законам псевдореферендум щодо статусу
            півострова. Результати не визнають ані Україна, ані Євросоюз, ані
            США, ані низка інших країн світу. В окупації Криму беруть участь
            близько 20 тисяч російських військових. Частину з них згодом
            перекинуть на Донбас.
          </p>
          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/D904718E-7E28-40C8-93BB-37CCEBA426F3_w1000.jpg'
              }
            />
            <span>
              Російська військова колона під Севастополем за п’ять днів
              псевдореферендуму
            </span>
          </TimelineImage>

          <TimelineSubtitle>18 березня</TimelineSubtitle>
          <p>
            У Сімферополі диверсійний загін ГРУ під керівництвом російського
            полковника Ігоря Гіркіна (Стрєлкова) захоплює картографічний центр.
            Військову частину обстрілюють із кулемета Калашнікова. Гине
            прапорщик ЗСУ Сергій Кокурін – це перший вбитий український
            військовий під час агресії Росії проти України.
          </p>
          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/D43B891B-48B0-4D34-9464-744E00FF9C0D_w1000.jpg'
              }
            />
          </TimelineImage>
          <p>
            Одночасно в Москві президент РФ Володимир Путін оголошує про так
            зване «приєднання Криму до Росії».
          </p>

          <TimelineSubtitle>24 березня</TimelineSubtitle>
          <p>
            Влада України заявляє про виведення українських військових з Криму
            на материкову частину України.
          </p>

          <TimelineSubtitle>6 квітня</TimelineSubtitle>
          <p>
            У селищі Новофедорівка Сакського району російський
            військовослужбовець Євген Зайцев застрелив українського офіцера
            Станіслава Карачевського, який не зрадив присязі на вірність народу
            України: це був другий убитий під час захоплення Криму український
            військовий. Надалі російське керівництво не раз називатиме
            захоплення Криму «безкровним».
          </p>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
